import React from "react"
import {Pane} from "evergreen-ui";
import TemporaryTurnPage from "../../Constructor/temporaryTurnConstructor/TemporaryTurnPage";
import PeriodsValuesPage from "../../Constructor/decadeConstructor/PeriodsValuesPage";
import RainFloodPage from "../../Constructor/rainFlood/RainFloodPage";
import RiverFloodPage from "../../Constructor/riverFlood/RiverFloodPage";
import EvaporationPage from "../../Constructor/evaporation/EvaporationPage";


export default function CreateViaTemplateDialog({constructorType}) {

    return (
        <Pane>
            {
                constructorType == 'DECADE'? <PeriodsValuesPage isEdit={true} /> :
                constructorType == 'TT' ? <TemporaryTurnPage isEdit={true} /> :
                constructorType == 'RAIN_FLOOD'? <RainFloodPage isEdit={true} /> :
                constructorType == 'RIVER_FLOOD' ? <RiverFloodPage isEdit={true} /> :
                constructorType == 'EVAPORATION' ? <EvaporationPage isEdit={true} /> :
                    <></>
            }
        </Pane>
    )
}